export const isBayer = () => (process.env.VUE_APP_CLIENT === 'BAYER');

export default isBayer;
